import styled from 'styled-components';

export const IntegrationDetailsWrapper = styled.div.attrs({
  className: 'container',
})``;

export const HeaderContainer = styled.div`
  display: flex;
  flex-direction: row;
  gap: 10px;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
`;
